"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("./create-validator");
exports.createRegexValidator = function (regex, message) { return create_validator_1.createValidatorFactory(function (s) { return !s || regex.test(s); }, message); };
